<div class="ClientLogo">
    <img [src]="imageUpload$" [ngClass]="{'ClientLogo--inverted': isNull == true }" />
</div>